'use client';

import { ShopClientWrapper } from './ShopClientWrapper.client';

/** Shop (and other non-login) document shell. */
export function ShopDocumentShell({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    return <ShopClientWrapper>{children}</ShopClientWrapper>;
}
